/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AllScheduleDto } from '../../models/all-schedule-dto';

export interface AllScheduleControllerFindToday$Params {
}

export function allScheduleControllerFindToday(http: HttpClient, rootUrl: string, params?: AllScheduleControllerFindToday$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, allScheduleControllerFindToday.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AllScheduleDto>;
    })
  );
}

allScheduleControllerFindToday.PATH = '/api/all-schedule/today';
